var chunkToChildrenMap = {
	"253": [
		8832
	],
	"940": [
		8832
	],
	"1269": [
		8832
	],
	"2543": [
		8832
	],
	"3856": [
		8832
	],
	"3929": [
		8832
	],
	"4550": [
		8832
	],
	"6653": [
		8832
	],
	"6833": [
		8832
	],
	"7359": [
		8832
	],
	"8829": [
		8832
	],
	"9279": [
		8832
	],
	"9742": [
		8832
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));